import styled from 'styled-components';
import { Icon } from '@phishtool/ui';
export const StyledFeatureList = styled.ul.withConfig({ displayName: "StyledFeatureList", componentId: "-zjx1aj" }) `
  margin: 0 0 ${(props) => props.theme.spacers.xxl};
  padding: 0;
  list-style: none;
  flex: 1;
`;
export const StyledFeatureListItem = styled.li.withConfig({ displayName: "StyledFeatureListItem", componentId: "-yuc0rz" }) `
  margin: 0 0 ${(props) => props.theme.spacers.medium};
  display: flex;
  gap: ${(props) => props.theme.spacers.small};
  align-items: center;
  font-size: 14px;

  &:last-child {
    margin: 0;
  }
`;
export const StyledFeatureListItemText = styled.span.withConfig({ displayName: "StyledFeatureListItemText", componentId: "-1dlqk11" }) `
  flex: 1;
`;
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon", componentId: "-wzy82m" }) `
  margin-bottom: ${(props) => props.theme.spacers.large};
`;
